/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'

export default function useResetPasswordFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const fields = {
        email: {
            name: `${prefix}email`,
            placeholder: formatMessage({
                defaultMessage: 'Email Address*',
                id: 'reset_password_form.message.email_placeholder'
            }),
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter a valid email address.',
                    id: 'use_reset_password_fields.error.required_email'
                }),
                pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: formatMessage({
                        defaultMessage: 'Enter a valid email address such as name@email.com.',
                        id: 'use_registration_fields.error.pattern_email'
                    })
                }
            },
            error: errors[`${prefix}email`],
            control
        }
    }

    return fields
}
